import React, { useState } from "react";
import { Form, Input, Button, Select, Typography, Spin } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { toast } from "react-toastify";

const { Title } = Typography;

const AdminAddCustomerAntD = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selectLanguage = i18next.language;
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("admin"));

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_APIURL}/admin/creatcustomer`,
        {
          method: "POST",
          body: JSON.stringify(values),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const response = await res.json();

      if (response?.status_code === 200) {
        toast.success(`${t("add_vendor_text")}`);
        navigate("/admin/customers");
      } else {
        toast.error(response?.message || response?.err || "Something went wrong");
      }
    } catch (error) {
      toast.error("Network error");
    }

    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-6 mt-6 rounded shadow">
      <Title level={4}>{t("add_customer")}</Title>

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="cust_fullname"
          label={t("form_name")}
          rules={[{ required: true, message: t("form_name") + " is required" }]}
        >
          <Input placeholder={t("form_name")} />
        </Form.Item>

        <Form.Item
          name="cust_email"
          label={t("form_email")}
          rules={[{ required: true, message: t("form_email") + " is required" }]}
        >
          <Input type="email" placeholder={t("form_email")} />
        </Form.Item>

        <Form.Item
          name="cust_contact"
          label={t("Phone Number")}
          rules={[{ required: true, message: t("Phone Number") + " is required" }]}
        >
          <PhoneInput
            country={"sa"}
            inputStyle={{ width: "100%" }}
            enableSearch
            inputProps={{ name: "cust_contact", required: true }}
            onChange={(value) => form.setFieldValue("cust_contact", value)}
          />
        </Form.Item>

        <Form.Item
          name="cust_password"
          label={`${t("New")} ${t("l_p")}`}
          rules={[{ required: true, message: t("Password is required") }]}
        >
          <Input.Password
            placeholder={`${t("New")} ${t("l_p")}`}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item
          name="cust_plan"
          label={t("Plan")}
          rules={[{ required: true, message: t("Plan is required") }]}
        >
          <Select placeholder={t("Plan")}>
            <Select.Option value="free">
              {selectLanguage === "ar" ? "خطة مجانية" : "Free Plan"}
            </Select.Option>
            <Select.Option value="starter">
              {selectLanguage === "ar" ? "بداية" : "Starter"}
            </Select.Option>
            <Select.Option value="advance">
              {selectLanguage === "ar" ? "يتقدم" : "Advance"}
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="domain_without_protocol"
          label={t("Domain Name Without Protocol")}
          rules={[{ required: true, message: t("Domain is required") }]}
        >
          <Input placeholder="example.com" />
        </Form.Item>

        <Form.Item
          name="full_domain"
          label={t("Full Domain Name With Protocol")}
          rules={[{ required: true, message: t("Full domain is required") }]}
        >
          <Input placeholder="https://example.com" />
        </Form.Item>

        <Form.Item>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary text-white"
          >
            {t("Save") || "Save"}
          </button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AdminAddCustomerAntD;
